import * as types from './constants';

export const setIsOnboardingOpen = status => ({
  type: types.SET_IS_ONBOARDING_OPEN,
  status
});

export const setIsFromRegistration = status => ({
  type: types.SET_IS_FROM_REGISTRATION,
  status
});

export const addSeenRoute = route => ({
  type: types.ADD_SEEN_ROUTE,
  route
});
